import { useEffect, useState } from 'preact/hooks'
import type { UpdateState } from '~/pwa/updateMachine'
import { getUpdateState, subscribeToUpdateState } from '~/services/updateService'

/** Subscribe a component to the service-worker update state (D-044). */
export function useUpdateState(): UpdateState {
  const [state, setState] = useState<UpdateState>(getUpdateState)

  useEffect(() => {
    // Re-read on mount: an update may have been detected between the initial
    // render and the subscription being established.
    setState(getUpdateState())
    return subscribeToUpdateState(setState)
  }, [])

  return state
}
